import { render, staticRenderFns } from "./myRepairDispatchManageList.vue?vue&type=template&id=bc85d722&scoped=true"
import script from "./myRepairDispatchManageList.vue?vue&type=script&lang=js"
export * from "./myRepairDispatchManageList.vue?vue&type=script&lang=js"
import style0 from "./myRepairDispatchManageList.vue?vue&type=style&index=0&id=bc85d722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc85d722",
  null
  
)

export default component.exports